// src/pages/Login/FindUsername.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Login.module.scss';
import { findUsername } from '../../store/session/action';
import { Link } from 'react-router-dom';
import GuestNaviBar from '../Guest/Navigator/GuestNaviBar';
import { emailPattern } from '../../utils/convertUtil';
import { apiErrorText } from '../../utils/apiError';
import toggleOpen from '../../assets/image/toggle_open.png';
import toggleClosed from '../../assets/image/toggle_close.png';

const FindUsername = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  // 비밀번호 칸 아래 오류인지 폼 전체 오류인지 구분합니다. 예전에는 errorMessage
  // 를 'Password is required.' 와 비교했는데, 번역하면 그 비교가 깨집니다.
  const [passwordRequired, setPasswordRequired] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setEmail(value);
      if (!value) {
        setEmailError(t('auth.err.emailEmpty'));
      } else if (!emailPattern.test(value)) {
        setEmailError(t('auth.err.emailInvalid'));
      } else {
        setEmailError('');
      }
    } else if (name === 'password') {
      setPassword(value);
      setPasswordRequired(!value);
      setIsError(!value);
      setErrorMessage('');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsError(false);
    setErrorMessage('');
    setPasswordRequired(false);

    if (!email) {
      setEmailError(t('auth.err.emailEmpty'));
      return;
    } else if (!emailPattern.test(email)) {
      setEmailError(t('auth.err.emailInvalid'));
      return;
    }

    if (!password) {
      setIsError(true);
      setPasswordRequired(true);
      return;
    }

    try {
      const response = await findUsername({ email, password });
      if (response.status === 200 && response.username) {
        setUsername(response.username);
      } else {
        setIsError(true);
        // postData 는 HTTP 오류를 던지지 않고 AxiosError 를 그대로 돌려주므로
        // 실패는 catch 가 아니라 여기로 옵니다.
        setErrorMessage(apiErrorText(response, 'auth.err.generic'));
      }
    } catch (error) {
      console.error('find username error: ', error);
      setIsError(true);
      setErrorMessage(t('auth.err.findUsernameFailed'));
    }
  };

  return (
    <>
      <GuestNaviBar />
      <div className={styles.loginContainer}>
        <div className={styles.loginBox}>
          <h2 className={styles.loginTitle}>{t('auth.findUsername.title')}</h2>
          {username ? (
            <p className={styles.successMessageLarge}>
              <span className={styles.messagePrefix}>
                {t('auth.findUsername.usernamePrefix')}
              </span>
              <span className={styles.username}>{username}</span>
            </p>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className={styles.inputContainer}>
                <input
                  type="email"
                  placeholder={t('auth.field.email')}
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  className={styles.noeye_inputField}
                />
                {emailError && (
                  <p className={styles.loginErrorMessage}>{emailError}</p>
                )}
              </div>
              <div className={styles.passwordInputContainer}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder={t('auth.field.password')}
                  name="password"
                  value={password}
                  onChange={handleInputChange}
                  className={styles.inputField}
                />
                <img
                  src={showPassword ? toggleOpen : toggleClosed}
                  alt={t('auth.alt.togglePassword')}
                  className={styles.togglePassword}
                  onClick={togglePasswordVisibility}
                />
                {passwordRequired && (
                  <p className={styles.loginErrorMessage}>
                    {t('auth.err.passwordRequired')}
                  </p>
                )}
              </div>
              <button type="submit" className={styles.loginButton}>
                {t('auth.findUsername.button')}
              </button>
            </form>
          )}
          {isError && errorMessage && !passwordRequired && (
            <p className={styles.loginErrorMessage}>{errorMessage}</p>
          )}
          <p className={styles.loginText}>
            {t('auth.findUsername.rememberUsername')}{' '}
            <Link to="/login" className={styles.loginLink}>
              {t('auth.findUsername.login')}
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default FindUsername;
